(function () {
  var ATTR_KEY = 'Data de nascimento';
  var FIELD_ID = 'decoronline-birthdate-field';
  var savedValue = '';

  function maskDate(value) {
    var digits = (value || '').replace(/\D/g, '').slice(0, 8);
    if (digits.length <= 2) return digits;
    if (digits.length <= 4) return digits.slice(0, 2) + '/' + digits.slice(2);
    return digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
  }

  function isValidDate(value) {
    if (!value) return true;
    var m = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return false;
    var d = Number(m[1]), mo = Number(m[2]), y = Number(m[3]);
    if (y < 1900 || y > new Date().getFullYear()) return false;
    var dt = new Date(y, mo - 1, d);
    return dt.getFullYear() === y && dt.getMonth() === mo - 1 && dt.getDate() === d;
  }

  function addStyles() {
    if (document.getElementById('decoronline-birthdate-style')) return;
    var style = document.createElement('style');
    style.id = 'decoronline-birthdate-style';
    style.textContent =
      '.decoronline-birthdate{width:100%;margin:0 0 14px;padding:12px 13px;border:1px solid rgba(23,33,43,.16);border-radius:8px;background:#fff;box-sizing:border-box}' +
      '.decoronline-birthdate label{display:block;margin:0 0 6px;font-size:13px;font-weight:650;color:#17212b}' +
      '.decoronline-birthdate input{width:100%;height:42px;padding:0 11px;border:1px solid rgba(23,33,43,.22);border-radius:6px;background:#fff;color:#17212b;font:inherit;box-sizing:border-box}' +
      '.decoronline-birthdate small{display:block;margin-top:6px;font-size:11.5px;line-height:1.35;color:rgba(23,33,43,.72)}' +
      '.decoronline-birthdate .dob-status{margin-top:5px;font-size:11px;min-height:14px}' +
      '.decoronline-birthdate .dob-error{color:#a12622}' +
      '.decoronline-birthdate .dob-saved{color:#376b3a}';
    document.head.appendChild(style);
  }

  function saveValue(value, statusEl) {
    if (!isValidDate(value)) {
      statusEl.textContent = 'Confira a data no formato DD/MM/AAAA.';
      statusEl.className = 'dob-status dob-error';
      return;
    }
    statusEl.textContent = value ? 'Salvando...' : '';
    statusEl.className = 'dob-status';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({attributes: (function(){ var o={}; o[ATTR_KEY]=value; return o; })()})
    })
      .then(function (r) { if (!r.ok) throw new Error('save'); return r.json(); })
      .then(function () {
        savedValue = value;
        statusEl.textContent = value ? 'Informação salva no pedido.' : '';
        statusEl.className = 'dob-status dob-saved';
      })
      .catch(function () {
        statusEl.textContent = 'Não foi possível salvar agora. Tente novamente.';
        statusEl.className = 'dob-status dob-error';
      });
  }

  function createField() {
    var wrap = document.createElement('div');
    wrap.className = 'decoronline-birthdate';
    wrap.setAttribute('data-decoronline-birthdate', 'true');

    var label = document.createElement('label');
    label.setAttribute('for', FIELD_ID + '-' + Math.random().toString(36).slice(2));

    var input = document.createElement('input');
    input.id = label.getAttribute('for');
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'bday';
    input.maxLength = 10;
    input.placeholder = 'DD/MM/AAAA';
    input.value = savedValue;
    input.setAttribute('aria-label', 'Data de nascimento');

    var help = document.createElement('small');
    help.textContent = 'Data de Nascimento';

    var status = document.createElement('div');
    status.className = 'dob-status';
    status.setAttribute('aria-live', 'polite');

    input.addEventListener('input', function () {
      var masked = maskDate(input.value);
      if (input.value !== masked) input.value = masked;
      status.textContent = '';
      status.className = 'dob-status';
    });

    input.addEventListener('change', function () {
      var value = input.value.trim();
      if (value === savedValue) return;
      saveValue(value, status);
    });

    input.addEventListener('blur', function () {
      var value = input.value.trim();
      if (value && value !== savedValue) saveValue(value, status);
    });

    
    wrap.appendChild(input);
    wrap.appendChild(help);
    wrap.appendChild(status);
    return wrap;
  }

  function inject() {
    addStyles();
    document.querySelectorAll('.cart-btn-container').forEach(function (container) {
      if (container.querySelector('[data-decoronline-birthdate]')) return;
      var checkout = container.querySelector('.checkout-btn, [name="checkout"], a[href*="/checkout"]');
      if (!checkout) return;
      container.insertBefore(createField(), checkout);
    });
  }

  function loadCart() {
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
      headers: {'Accept': 'application/json'}
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        savedValue = cart && cart.attributes && cart.attributes[ATTR_KEY] ? cart.attributes[ATTR_KEY] : '';
        inject();
      })
      .catch(function () { inject(); });
  }

  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      inject();
    });
  });

  function start() {
    loadCart();
    observer.observe(document.documentElement, {childList: true, subtree: true});
    document.addEventListener('cart:updated', inject);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();